module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bc-slide-menu",
    class: {
      'bc-slide-menu--open': _vm.visible
    }
  }, [_c('div', {
    staticClass: "bc-slide-menu__backdrop",
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "bc-slide-menu__panel",
    class: {
      'bc-slide-menu__panel--open': _vm.visible
    }
  }, [_c('div', {
    staticClass: "bc-slide-menu__bg",
    style: (_vm.bgStyle)
  }), _vm._v(" "), _c('div', {
    staticClass: "bc-slide-menu__overlay"
  }), _vm._v(" "), _c('div', {
    staticClass: "bc-slide-menu__content"
  }, [_c('button', {
    staticClass: "bc-slide-menu__close",
    attrs: {
      "type": "button",
      "aria-label": "close"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n        ×\n      ")]), _vm._v(" "), _c('nav', {
    staticClass: "bc-slide-menu__nav",
    class: {
      'bc-slide-menu__nav--with-footer': _vm.$slots.footer
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('button', {
      key: _vm.itemKey(item, index),
      staticClass: "bc-slide-menu__link",
      attrs: {
        "type": "button"
      },
      on: {
        "click": function($event) {
          return _vm.onItem(item)
        }
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.linkLabel(item)))]), _vm._v(" "), _c('BcMenuLinkIcon', {
      attrs: {
        "name": item.icon || 'info'
      }
    })], 1)
  }), 0), _vm._v(" "), (_vm.$slots.footer) ? _c('div', {
    staticClass: "bc-slide-menu__footer"
  }, [_vm._t("footer")], 2) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b010e8b6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/mainindex/BcSlideMenu.vue
// module id = 1532
// module chunks = 0